<template>
  <div class="toolbar d-flex py-2 py-lg-0">
    <div class="toolbar-item d-flex align-items-center justify-content-center"
      :class="{'gap-3' : isCompare}">
      <a class="d-block action-btn p-2"
         style="cursor: pointer"
         @mousedown="mouseDown(zoomRate)"
         @mouseup="mouseUp"
         @dragstart="mouseUp"
      >
        <img src="/img/review/icons/zoom-in.svg" class="d-block" width="20" height="20" alt="">
      </a>
      <a @click="toggleZoomMode" x-data="{zoomWidth : true}" class="action-btn p-2" style="cursor: pointer">
        <img x-cloak :class="zoomMode === 0 ? 'd-block' : 'd-none' " x-show="zoomWidth"
             src="/img/review/icons/zoom-Icon.svg" width="25" height="20" alt="">
        <img x-cloak :class="zoomMode === 1 ? 'd-block' : 'd-none' " src="/img/review/icons/zoom-height.svg" width="25"
             height="20" alt="">
      </a>
      <a class="d-block action-btn p-2"
         style="cursor: pointer"
         @mousedown="mouseDown(-1 * zoomRate)"
         @mouseup="mouseUp"
         @dragstart="mouseUp"
      >
        <img src="/img/review/icons/zoom-out.svg" class="d-block" width="20" height="20" alt="">
      </a>
      <!-- Zoom Percentage Input -->
      <div class="zoom-percentage-input d-flex align-items-center mx-2">
        <input
          type="number"
          v-model="zoomPercentageInput"
          @keyup.enter="updateZoomFromPercentage"
          @blur="updateZoomFromPercentage"
          min="10"
          max="500"
          step="5"
          class="form-control zoom-input"
          title="Zoom percentage (10% - 500%)"
        />
        <span class="percentage-symbol">%</span>
      </div>
      <a v-if="showRotate" class="d-block action-btn p-2" @click="rotate()" style="cursor: pointer">
        <img src="/img/review/icons/rotate-right.svg" class="d-block" width="20" height="20" alt="">
      </a>
      <a class="d-block action-btn p-2" v-if="isDragableFile && isThirdWheelZoomActive" @click="toggleDragMode()" style="cursor: pointer" :class="{'drag-mode-selected': isDragEnabled}">
        <img src="/img/review/icons/drag-icon.svg" class="d-block" width="20" height="20" alt="drag-icon">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "proof-view-zoom-tools",
  props : ['updateZoom', 'curZoom', 'zoomMode', 'rotate', 'toggleZoomMode', 'isCompare', 'curFile', 'showRotate', 'toggleDragMode', 'isDragEnabled', 'isDragableFile', 'isThirdWheelZoomActive'],
  data : () => ({
    isMouseDown : false,
    zoomIncrement : 0,
    zoomRate: 0.025,
    zoomInterval: 50,
    zoomPercentageInput: 100
  }),
  computed: {
    zoomPercentage() {
      return Math.round((this.curZoom || 1) * 100);
    }
  },
  watch: {
    zoomPercentage(newVal) {
      this.zoomPercentageInput = newVal;
    }
  },
  mounted() {
    this.zoomPercentageInput = this.zoomPercentage;
  },
  methods : {
    mouseDown(zoomIncrement){
      this.isMouseDown = true;
      this.zoomIncrement = zoomIncrement;
      this.updateZoom(this.curZoom + this.zoomIncrement);
      setTimeout(this.whileMouseDown, 200);
    },
    whileMouseDown() {
      if (!this.isMouseDown) return;
      this.updateZoom(this.curZoom + this.zoomIncrement);
      setTimeout(this.whileMouseDown, this.zoomInterval);
    },
    mouseUp() {
      this.isMouseDown = false;
    },
    updateZoomFromPercentage() {
      let percentage = parseInt(this.zoomPercentageInput);
      
      // Validation
      if (isNaN(percentage)) {
        this.zoomPercentageInput = this.zoomPercentage;
        return;
      }
      
      // Clamp between 10% and 500%
      percentage = Math.max(10, Math.min(500, percentage));
      this.zoomPercentageInput = percentage;
      
      // Convert percentage to decimal and update zoom
      const zoomDecimal = percentage / 100;
      this.updateZoom(zoomDecimal);
    }
  }
}
</script>

<style scoped>

[x-cloak]{
  display: none;
}

.drag-mode-selected {
  background-color: rgb(209 213 219);
  border-radius: 4px;
}

.zoom-percentage-input {
  position: relative;
  min-width: 80px;
}

.zoom-input {
  width: 60px;
  height: 32px;
  font-size: 14px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 4px 8px;
  background-color: white;
}

.zoom-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.percentage-symbol {
  margin-left: 2px;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}
</style>
